<template>
    <body>
    <div class="card_office">
        <img src="../assets/serpi_main.jpeg" alt="Offices" style="width:100%">
        <h1><i class="fa fa-map-marker" aria-hidden="true"></i> Offices</h1>
        <p class="price">{{countOffices}}</p>
        <p>View & Manage</p>
        <p><button :disabled="isSuspended" @click="selectOffices">Select</button></p>
    </div>
    <div class="card_business">
        <img src="../assets/serpi_main.jpeg" alt="Offices" style="width:100%">
        <h1><i class="fa fa-id-badge" aria-hidden="true"></i> Business Account</h1>
        <p class="price">{{showBusinessName}}</p>
        <p class="active_till">
            <span v-if="isSuspended" style="color: lightpink">
                <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                <span style="font-size: 12px;margin-left: 5px;margin-right: 5px">Suspended on</span>
            </span>
            <span v-else style="color: lime;margin-right: 5px"> Valid until
                <i class="fa fa-calendar-check-o" aria-hidden="true"></i>
            </span>
            <span style="font-size: 8px">{{computeActiveTime}}</span>
        </p>
        <p v-if="!isSuspended"><button @click="selectBusiness">Select</button></p>
        <p v-else><button @click="renewActiveTime">Renew</button></p>
    </div>
    <div class="card_appo">
        <img src="../assets/serpi_main.jpeg" alt="Offices" style="width:100%">
        <h1><i class="fa fa-calendar" aria-hidden="true"></i> Appointments</h1>
        <p class="price">{{showLiveAppo}}</p>
        <p>View & Manage</p>
        <p><button :disabled="isSuspended" @click="selectAppointments">Select</button></p>
    </div>
    </body>
</template>
<script>
    import {getBaseURL} from '../url_endpoints'
    export default {
        name: 'Features',
        data() {
            return  {
                baseURL:null,
            }
        },
        computed:{
            isSuspended() {
                return !this.$store.getters.getSuspendedAccount ? false : this.$store.getters.getSuspendedAccount
            },
            countOffices() {
              return !this.$store.getters.getNoOffices ? 0 : this.$store.getters.getNoOffices
            },
            showBusinessName() {
             return !this.$store.getters.getCurrentBusiness ? '' : this.$store.getters.getCurrentBusiness.name
            },
            showLiveAppo() {
              return !this.$store.getters.getLiveAppointments ? 0 : this.$store.getters.getLiveAppointments
            },
            computeActiveTime() {
              if(!this.$store.getters.getCurrentBusiness) {
                  return '1970-01-01'
              }else {
                  const stime = this.$store.getters.getCurrentBusiness.subscription_time
                  const num_months = this.$store.getters.getCurrentBusiness.subscription_months
                  let d = new Date(stime)
                  if(isNaN(d)) {
                      // SAFARI case - compute in different way
                      const datearray = stime.split('-')
                      d = new Date(datearray[0],datearray[1],datearray[2])
                      d.setMonth(d.getMonth() + num_months)
                  } else {
                      d.setMonth(d.getMonth() + num_months+1) // add 1 ,because january = 0 for Chrome
                  }
                  //console.log('Month end: ', d.getMonth())
                  const now = new Date()
                  if( now.getTime() > d.getTime()) {
                      //set inactive features - suspended account
                      this.$store.commit('setSuspendedAccount',true)
                  }
                  return d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate()
              }
            }
        },
        mounted() {
            this.baseURL = getBaseURL()
            this.countBusinessOffices()
            this.countBusinessAppointments()
        },
        methods: {
            selectAppointments() {
              this.$router.push('/business_appointments')
                window.scrollTo(0,0)
            },
            selectOffices() {
                this.$router.push('/business_offices')
                window.scrollTo(0,0)
            },
            selectBusiness() {
              this.$router.push('/new_business')
                window.scrollTo(0,0)
            },
            renewActiveTime() {
                this.$router.push('/payment')
                window.scrollTo(0,0)
            },
            countBusinessOffices() {
                const business = this.$store.getters.getCurrentBusiness
                fetch(this.baseURL + '/offices?bid='+business.id).then(rsp => {
                    return rsp.json()
                }).then( response => {
                    //console.log(response)
                    let offices = []
                    for(let office of response) {
                        offices.push(office)
                    }
                    // store number of offices for current business
                    this.$store.commit('setNumberOffices',offices.length)
                }).catch(err => {
                    alert(err.message+'\nBackend Server could be down!\nPlease try again later....')
                    //console.log('Error when get offices', err.message)
                })
            },
            countBusinessAppointments() {
                const business = this.$store.getters.getCurrentBusiness
                fetch(this.baseURL + '/appointments?bid='+business.id).then(rsp => {
                    return rsp.json()
                }).then( response => {
                    let appointments = []
                    //console.log(response)
                    for(let a of response) {
                        appointments.push(a)
                    }
                    this.$store.commit('setLiveAppointments',appointments.length)
                }).catch(err => {
                    alert(err.message+'\nBackend Server not working!\nPlease try again later....')
                    this.error_message = 'Backend Server could be down!'
                    //console.log('Error when get appointments', err.message)
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
    body {
        height:200vh;
    }
    h1 {
        font-size: 20px;
    }
    .card {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
        width: 30%;
        margin-left: 20px;
        margin-top: 40px;
        text-align: center;
        font-family: arial;
        background-color: lightslategrey;
        float: left;
        opacity: 0.7;
    }
    .card:hover {
        opacity: 1.0;
    }
    .card_office {
        @extend .card;
    }
    .card_office:hover {
        background-color: dodgerblue;
    }
    .card_appo {
        @extend .card;
    }
    .card_appo:hover {
        background-color: lightseagreen;
    }
    .card_business {
        @extend .card;
    }
    .card_business:hover {
        background-color: lightsalmon;
    }

    .price {
        color: black;
        font-size: 22px;
    }

    .card button {
        border: none;
        outline: 0;
        padding: 12px;
        color: white;
        background-color: dimgray;
        text-align: center;
        cursor: pointer;
        width: 100%;
        font-size: 18px;
    }

    .card button:hover {
        opacity: 0.7;
        background-color: lightcyan;
        color:black;
    }
    .card button:disabled {
        background-color: lightgray;
        cursor: crosshair;
    }
    .active_till {
        //background-color: lightseagreen;
        cursor: zoom-in;
        //padding:5px;
        font-weight: bold;
    }
    .active_till:hover {
        opacity:0.9;
        color: indigo;
    }
    .QRimg {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: 150px;
    }

    .QRimg:hover {
        box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
    }
    .msg {
        font-size: 15px;
    }
    // make responsive
    @media screen and (max-width: 600px) {
        .card {
            width: 90%;
            margin-left: 20px;
            margin-top: 20px;
        }
        .QRimg{
            width: 100px;
        }
        .msg {
            font-size: 10px;
        }
    }

</style>